import { render, staticRenderFns } from "./EventChatVideosReveals.vue?vue&type=template&id=367e64d5&"
import script from "./EventChatVideosReveals.vue?vue&type=script&lang=js&"
export * from "./EventChatVideosReveals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports